// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Section_elSection__3N6l4 {\n  margin-bottom: 16px; }\n\n.Section_warningModal__149TP {\n  width: 450px !important; }\n", ""]);
// Exports
exports.locals = {
	"elSection": "Section_elSection__3N6l4",
	"warningModal": "Section_warningModal__149TP"
};
module.exports = exports;
